<app-spinner [visible]="!!visibleSpinner"></app-spinner>
<p-breadcrumb [model]="breadCrumbItems"></p-breadcrumb>

<app-mensajes [code]="code" [titulo]="titulo" [detalle]="detalle" [sw]="sw"></app-mensajes>

<p-confirmDialog [style]="{ width: '50vw' }" [baseZIndex]="10000" acceptLabel="Ok"></p-confirmDialog>
<app-spinner [visible]="visibleSpinner"></app-spinner>
<div class="p-grid p-jc-center p-my-1">

  <div class="p-col-12 p-md-12 p-xl-12" *ngIf="visibleForm">
    <div class="p-col-12 custom-title--tramite">
      <h2 class="custom-title--text" style="color: #212121;">{{tramite}} {{numeroSolicitud ? '- Solicitud #' +
        numeroSolicitud : ''}}</h2>
    </div>
    <p-card *ngIf="this.form" class="p-card--noshadow">
      <div class="p-col-12">
        <ng-container *ngIf="!form.commentable">
          <div *ngFor="let observation of obsGeneral;">
            <div class="pretty-alert pretty-alert--warn ng-star-inserted">
              <div class="pretty-alert--icon" style="font-weight: bold;">
                <i class="pi pi-exclamation-triangle"></i>
              </div>
              <div class="pretty-alert--separator--h"></div>
              <div class="pretty-alert--message">
                <p><span style="font-weight: bold;">Observación Gral. {{observation.dictamen}}: </span><span
                    [innerHTML]="observation.value"></span></p>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <app-dynamic-form [form]="form" (events)="onFormEvent($event)" [outsideEvents]="events"></app-dynamic-form>
      <p-footer *ngIf="editable">
        <button type="submit" label="Enviar Solicitud" pButton icon="pi pi-reply" (click)="enviar()"
          style="float: left;" tooltipPosition="top"
          pTooltip="Envía la solicitud para que sea revisada por personal de DNM, después de enviarla no se puede modificar"
          class="d-button-send"></button>
        <button type="submit" label="Guardar en borrador" pButton icon="pi pi-save" (click)="onSave()"
          style="float: right;" tooltipPosition="top"
          pTooltip="Permite continuar con el llenado de la solicitud en otro momento sin perder la información digitada (la solicitud no se envía para revisión)"
          class="d-button-save"></button>
        <ul><br><br></ul>
      </p-footer>
    </p-card>
  </div>
</div>